module.exports = __webpack_public_path__ + "code-launch.2An_jPB9.svg";